import { zoneInset, cardDraggable } from "@design-system";

export type { ICargo, EnhancedRouteItem } from "../../types/order/IRouteItem";

export interface BaseStopProps {
  isAvailable?: boolean;
  stopDisplayName?: string;
  orderDisplayName?: string;
  pickupStopNumber?: number;
}

export const ZONE_IDS = {
  AVAILABLE: "available-zone",
  ROUTE: "route-zone",
} as const;

export const STYLE_CLASSES = {
  CONTAINER: `${zoneInset} min-h-[78px] flex`,
  CARD: cardDraggable,
  TOOLTIP:
    "absolute right-0 top-full mt-2 z-50 bg-gray-900 text-white text-xs rounded-lg py-2 px-3 shadow-lg w-[250px] backdrop-blur-sm bg-opacity-90",
} as const;
